// import logo from "./asset-source/logo.gif";
import "./crypto.styles.css";
import toggle from "./asset-source/toggle.svg";
import arrV from "./asset-source/arr-v-crypto.svg";
import eq from "./asset-source/eq.svg";
import goto from "./asset-source/goto.svg";
import plane31 from "./asset-source/plane31.png";
import cardbg from "./asset-source/cardbg.jpg";
import binlogo from "./asset-source/binlogo.svg";
import binCase from "./asset-source/binCase.jpg";
import levelsCrypto from "./asset-source/levels-crypto.png";
import planet from "./asset-source/crypto-planet.png";

import plane from "./asset-source/plane-b.svg";

import s1 from "./asset-source/crypto2.png";
import s2 from "./asset-source/ecommerce2.png";
import s3 from "./asset-source/corporate1.png";
import s4 from "./asset-source/dec2.png";
import s5 from "./asset-source/ss5.png";

import logoW from "./asset-source/logo-w.svg";
import close from "./asset-source/close.svg";

//cases
import caseBoost from "./asset-source/boostpad-case-2.png";
import logoboostpad from "./asset-source/boostpadlogo.svg";

import caseGenshiro from "./asset-source/genshiro-cover.jpg";
import logoGenshiro from "./asset-source/genshiro-logo.svg";

import case1 from "./asset-source/case1.jpg";

import { useState, useEffect } from "react";
import Slider from "react-slick";
import { Header } from "./components/header-new/header";
import { Footer } from "./components/footer/footer";

import sl1 from "./asset-source/sl1.svg";
import sl2 from "./asset-source/sl2.svg";
import sl3 from "./asset-source/sl3.svg";
import sl4 from "./asset-source/sl4.svg";
import sl5 from "./asset-source/sl5.svg";
import sl6 from "./asset-source/sl6.svg";
import sl7 from "./asset-source/sl7.svg";
import sl8 from "./asset-source/sl8.svg";
import cryptobg from "./asset-source/Crypt-wjet-header-1.jpg";
import cryptobgmobile from "./asset-source/Crypt-mobile-wjet-header-1.jpg";
import CryptoFaq from "./components/crypto-faq/crypto-faq";

import ContactUsModal from "./components/modal/contact-us";
import { useNavigate } from "react-router-dom";

function CryptoPage() {
  const [isMenuActive, setIsMenuActive] = useState(false);
  const [currentField, setCurrentField] = useState("");
  const [fullProjects, setFullProjects] = useState(false);

  const navigate = useNavigate();

  const settings = {
    dots: false,
    infinite: true,
    arrows: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 14000,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  // setInterval(() => {
  //   shine();
  // }, 15005);

  // useEffect(() => {
  // 	if (modal || isMenuActive) {
  // 		document.body.style.overflow = "hidden";
  // 	} else {
  // 		document.body.style.overflow = "auto";
  // 	}
  // }, [modal, isMenuActive]);

  document.title = "Дизайн цифровых блокчейн-продуктов — web3, crypto, NFT";
  document.getElementsByTagName("META")[2].content =
    "UX/UI дизайн для цифровых продуктов на технологиях блокчейн: web3, крипто и NFT. Простые и интуитивные интерфейсы для сложных технологий. Разработка под ваши задачи с учетом трендов и потребностей";

  document.getElementsByTagName("META")[3].content =
    "дизайн блокчейн-продуктов, UX/UI дизайн web3, дизайн криптопроектов, дизайн интерфейсов NFT, UX дизайн блокчейн, цифровые продукты web3, дизайн для криптовалют, web3 дизайн интерфейсов, UX/UI для NFT, блокчейн-продукты дизайн";

  return (
    <div
      className="App crypto"
      onClick={() => {
        setCurrentField("");
      }}
    >
      <Header
        onLight
        isTitlePage
      />

      <section
        className="mainpage__top"
        id="top"
      >
        <img
          src={cryptobg}
          alt=""
          className="cryptobg"
        />
        <img
          src={cryptobgmobile}
          alt=""
          className="cryptobgmobile"
        />

        <div className="container">
          <div className="left">
            <h1 className="h1 h1--main">
              Дизайн цифровых
              <br />
              <span>Crypto&nbsp;Web3&nbsp;NFT</span>
              <br />
              продуктов
              <img
                src={toggle}
                alt=""
                className="toggle"
              />
            </h1>
            <p className="top__text">
              Создаём решения, которые превращают сложные блокчейн технологии
              в&nbsp;понятные и&nbsp;доступные для&nbsp;обычных пользователей
            </p>

            <button
              onClick={() => {
                navigate(`?modal`);
              }}
              className="btn"
            >
              Запланировать консультацию
            </button>
          </div>
        </div>
      </section>

      <section
        className="cases mainpage__cases"
        id="cases"
      >
        <div className="container">
          <h2 className="h2">Web 3 продукты, которые мы создали</h2>

          <a
            href="/web3-eq-product-page"
            className="case__item"
            target="_blank"
            rel="noreferrer"
          >
            <div className="case__info">
              <div>
                <div className="case__title">
                  Децентрализованная крипто биржа универсальных инструментов
                </div>
                <div className="case__desciption">
                  <div className="case__desciptiontitle">
                    Что&nbsp;мы&nbsp;сделали для&nbsp;Equilibrium?
                  </div>
                  <div className="case__desciptionunit">
                    Разработали продуктовую страницу с фокусом на удобстве и
                    конверсии
                  </div>
                  <div className="case__desciptionunit">
                    Разработали адаптивный дизайн для всех устройств
                  </div>
                  <div className="case__desciptionunit">
                    Применили 3D графику и визуальные элементы для оптимального
                    восприятия и взаимодействия
                  </div>
                </div>
              </div>

              <div className="case__button">
                <img
                  src={eq}
                  alt=""
                />
                <img
                  src={arrV}
                  alt=""
                  className="arr-v"
                />
              </div>
            </div>
            <div className="case__pic">
              <img
                src={case1}
                alt=""
              />
            </div>
          </a>

          <a
            href="/boostpad-ux-ui-launchpad"
            className="case__item"
            target="_blank"
            rel="noreferrer"
          >
            <div className="case__info">
              <div>
                <div className="case__title">Крипто лаунчпад платформа</div>
                <div className="case__desciption">
                  <div className="case__desciptiontitle">
                    Что мы сделали для BoostPad?
                  </div>
                  <div className="case__desciptionunit">
                    Создали простой и интуитивный интерфейс для криптолаунчпада{" "}
                  </div>
                  <div className="case__desciptionunit">
                    Продумали и спроектировали путь пользователя так,
                    чтобы даже сложные процессы были ясны и последовательны
                  </div>
                  <div className="case__desciptionunit">
                    Разработали таймлайн, который наглядно показывает все этапы
                    и помогает пользователям ориентироваться
                  </div>
                </div>
              </div>
              <div className="case__button">
                <img
                  src={logoboostpad}
                  alt=""
                />
                <img
                  src={arrV}
                  alt=""
                  className="arr-v"
                />
              </div>
            </div>
            <div className="case__pic">
              <img
                src={caseBoost}
                alt=""
              />
            </div>
          </a>

          <a
            href="/invest"
            className="case__item"
            target="_blank"
            rel="noreferrer"
          >
            <div className="case__info">
              <div>
                <div className="case__title">
                  Платформа для разумных инвестиций
                </div>
                <div className="case__desciption">
                  <div className="case__desciptiontitle">
                    Что мы сделали для Bin?
                  </div>
                  <div className="case__desciptionunit">
                    Создали простой и интуитивный интерфейс для криптолаунчпада
                  </div>
                  <div className="case__desciptionunit">
                    Продумали и спроектировали путь пользователя так,
                    чтобы даже сложные процессы были ясны и последовательны
                  </div>
                  <div className="case__desciptionunit">
                    Разработали таймлайн, который наглядно показывает все этапы
                    и помогает пользователям ориентироваться
                  </div>
                </div>
              </div>
              <div className="case__button">
                <img
                  src={binlogo}
                  alt=""
                />
                <img
                  src={arrV}
                  alt=""
                  className="arr-v"
                />
              </div>
            </div>
            <div className="case__pic">
              <img
                src={binCase}
                alt=""
              />
            </div>
          </a>

          <div className="projects__title allProjectsTitle">
            <img
              src={plane}
              alt=""
            />
            Все проекты
          </div>

          <div
            className={
              fullProjects ? "full projects__wrapper" : "projects__wrapper"
            }
          >
            <div className="projects__item">
              <div className="projects__name">Eesee</div>
              <div className="projects__desc">
                Ускорение продаж, снижение ценового барьера для выхода на рынок
                Web3 (rwa, NFT, tokens). Launchpad платформа
              </div>
              <a
                href="https://eesee.io"
                className="projects__button"
                target="_blank"
                rel="noreferrer"
              >
                Перейти
                <img
                  src={arrV}
                  alt=""
                />
              </a>
            </div>

            <div className="projects__item">
              <div className="projects__name">equilibrium.io</div>
              <div className="projects__desc">
                Платформа управления работой. Инструменты для планирования,
                управления
              </div>
              <a
                href="/web3-eq-product-page"
                className="projects__button"
                target="_blank"
                rel="noreferrer"
              >
                Перейти
                <img
                  src={arrV}
                  alt=""
                />
              </a>
            </div>

            <div className="projects__item">
              <div className="projects__name">goodday.work</div>
              <div className="projects__desc">
                Платформа управления работой. Инструменты для планирования,
                управления проектами
              </div>
              <a
                href="http://goodday.work"
                className="projects__button"
                target="_blank"
                rel="noreferrer"
              >
                Перейти
                <img
                  src={arrV}
                  alt=""
                />
              </a>
            </div>

            <div className="projects__item">
              <div className="projects__name">genshiro.io</div>
              <div className="projects__desc">
                DeFi platform with high leverage
              </div>
              <a
                href="https://genshiro.io/en"
                className="projects__button"
                target="_blank"
                rel="noreferrer"
              >
                Перейти
                <img
                  src={arrV}
                  alt=""
                />
              </a>
            </div>

            <div className="projects__item">
              <div className="projects__name">TON kitties</div>
              <div className="projects__desc">
                Telegram кликер. Заведи крипто-котика
              </div>
              <div className="projects__soon"> Скоро</div>
            </div>

            <div className="projects__item">
              <div className="projects__name">uktlab</div>
              <div className="projects__desc">
                Современная система речевой аналитики для uktlab.ru
              </div>
              <a
                href="https://uktlab.ru"
                className="projects__button"
                target="_blank"
                rel="noreferrer"
              >
                Перейти
                <img
                  src={arrV}
                  alt=""
                />
              </a>
            </div>

            <div className="projects__item">
              <div className="projects__name">PRO-BIKE</div>
              <div className="projects__desc">
                Ведущая компания на велорынке. Интернет-магазин
              </div>
              <a
                href="https://pro-bike.ru"
                className="projects__button"
                target="_blank"
                rel="noreferrer"
              >
                Перейти
                <img
                  src={arrV}
                  alt=""
                />
              </a>
            </div>
            <div className="projects__item">
              <div className="projects__name">rentskill</div>
              <div className="projects__desc">
                Платформа аренды жилья посуточно
              </div>
              <a
                href="https://rentskill.ru"
                className="projects__button"
                target="_blank"
                rel="noreferrer"
              >
                Перейти
                <img
                  src={arrV}
                  alt=""
                />
              </a>
            </div>
            <div className="projects__item">
              <div className="projects__name">Мебель без переплат</div>
              <div className="projects__desc">
                Первый в России. Сервис мебельных услуг без посредников
              </div>
              <div className="projects__soon"> Скоро</div>
            </div>
          </div>

          <button
            className="btn showmore"
            onClick={() => {
              setFullProjects(!fullProjects);
            }}
          >
            Показать {fullProjects ? "меньше" : "еще"}
          </button>
        </div>
      </section>

      <section className="crypto__ready">
        <div className="container">
          <div className="ready__content">
            <h2 className="h2">Готовы обсудить ваш web3/crypto продукт?</h2>
            <div>
              Оставьте нам&nbsp;сообщение, и&nbsp;мы&nbsp;свяжемся с&nbsp;вами
              в&nbsp;течение рабочего дня. Обсудим ваши задачи, расскажем,
              как&nbsp;можем помочь, и&nbsp;предложим оптимальное решение
              для&nbsp;вашего проекта.
            </div>

            <button
              onClick={() => {
                navigate(`?modal`);
              }}
              className="btn"
            >
              Обсудить проект
            </button>
          </div>
          <div className="ready__planet">
            <img
              src={planet}
              alt=""
            />
          </div>
        </div>
      </section>

      <section
        id="principles"
        className="principles__section"
      >
        <div className="sectionContent principles__grid">
          <div className="principles__left">
            <h2 className="h2">
              Принципы, которыми мы руководствуемся при работе с{" "}
              <span className="web3">web3</span> проектами
            </h2>
            <img
              src={levelsCrypto}
              alt=""
              className="levelsCrypto"
            />
          </div>

          <div className="principles__right">
            <div className="principle">
              <div className="principle__num">1</div>
              <div>
                <div className="principle__title">
                  Понятные интерфейсы для сложных технологий
                </div>
                <div>
                  <div className="principle__content principle__content--active">
                    Блокчейн-продукты должны быть настолько простыми и удобными,
                    чтобы пользователи даже не замечали, насколько эта сфера
                    сложна
                  </div>
                </div>
              </div>
            </div>
            <div className="principle">
              <div className="principle__num">2</div>
              <div>
                <div className="principle__title">
                  Дизайн, отражающий специфику Web3
                </div>
                <div>
                  <div className="principle__content principle__content--active">
                    Дизайн должен органично вписываться в мир криптоаудитории,
                    учитывать её цели, потребности и тренды, чтобы продукт
                    оставался актуальным, удобным и востребованным.
                  </div>
                </div>
              </div>
            </div>
            <div className="principle">
              <div className="principle__num">3</div>
              <div>
                <div className="principle__title">
                  Дизайн как часть экосистемы криптопродукта
                </div>
                <div>
                  <div className="principle__content principle__content--active">
                    Дизайн — это не только визуальная составляющая, но и
                    ключевой инструмент, который помогает выстроить структуру,
                    улучшить функционал и достичь бизнес-целей криптопроекта
                  </div>
                </div>
              </div>
            </div>
            <div className="principle">
              <div className="principle__num">4</div>
              <div>
                <div className="principle__title">Гибкость и адаптивность</div>
                <div>
                  <div className="principle__content principle__content--active">
                    В мире Web3 изменения происходят молниеносно. Дизайн должен
                    быть гибким, чтобы легко адаптироваться к новым функциям,
                    запросам рынка и масштабированию
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        className="products"
        id="products"
      >
        <div className="container">
          <div className="products__title">
            Web3 продукты, которые вы можете создать вместе с нами
          </div>
          <div className="products__grid">
            <div className="products__column">
              <div className="products__card corp">
                <div className="products__hover">
                  <div className="dotz">
                    <div className="dotz__row">
                      <div className="dotz__item shine delay1"></div>
                      <div className="dotz__item shine"></div>
                      <div className="dotz__item dotz__item--empty"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item shine delay1"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item "></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item "></div>
                      <div className="dotz__item shine"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item unshine"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item dotz__item--empty"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item "></div>
                      <div className="dotz__item unshine4"></div>
                      <div className="dotz__item shine delay1"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item dotz__item--empty"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item dotz__item--empty"></div>
                      <div className="dotz__item"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item inshune delay3"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item shine"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item "></div>
                      <div className="dotz__item shine delay2"></div>
                      <div className="dotz__item dotz__item--empty"></div>
                      <div className="dotz__item "></div>
                      <div className="dotz__item dotz__item--empty"></div>
                      <div className="dotz__item"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item unshine4"></div>
                      <div className="dotz__item "></div>
                      <div className="dotz__item "></div>
                      <div className="dotz__item unshine delay3"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item unshine delay3"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item "></div>
                      <div className="dotz__item "></div>
                      <div className="dotz__item "></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item unshine delay3"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item "></div>
                      <div className="dotz__item shine"></div>
                      <div className="dotz__item "></div>
                      <div className="dotz__item unshine"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item dotz__item--empty"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item "></div>
                      <div className="dotz__item shine delay2"></div>
                      <div className="dotz__item "></div>
                      <div className="dotz__item dotz__item--empty"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item dotz__item--empty"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item shine delay3"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item unshine delay1"></div>
                      <div className="dotz__item "></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item dotz__item--empty"></div>
                      <div className="dotz__item"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item"></div>
                      <div className="dotz__item unshine4"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item unshine delay1"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item shine"></div>
                      <div className="dotz__item unshine delay1"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item "></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item unshine"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item dotz__item--empty"></div>
                      <div className="dotz__item"></div>
                    </div>
                  </div>
                </div>
                <div className="products__icon">
                  <img
                    src={s3}
                    alt=""
                    className="products__icon--main"
                  />
                  <img
                    src={s3}
                    alt=""
                    className="products__icon--sub"
                  />
                </div>
                <div>
                  <div className="products__cardtitle">
                    Лаунчпады
                    {/* <img src={goto} alt="" className="goto" /> */}
                  </div>
                </div>
              </div>
              <div className="products__card">
                <div className="products__hover">
                  <div className="dotz">
                    <div className="dotz__row">
                      <div className="dotz__item shine delay1"></div>
                      <div className="dotz__item shine"></div>
                      <div className="dotz__item dotz__item--empty"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item shine delay1"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item "></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item "></div>
                      <div className="dotz__item shine"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item unshine"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item dotz__item--empty"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item "></div>
                      <div className="dotz__item unshine4"></div>
                      <div className="dotz__item shine delay1"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item dotz__item--empty"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item dotz__item--empty"></div>
                      <div className="dotz__item"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item inshune delay3"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item shine"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item "></div>
                      <div className="dotz__item shine delay2"></div>
                      <div className="dotz__item dotz__item--empty"></div>
                      <div className="dotz__item "></div>
                      <div className="dotz__item dotz__item--empty"></div>
                      <div className="dotz__item"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item unshine4"></div>
                      <div className="dotz__item "></div>
                      <div className="dotz__item "></div>
                      <div className="dotz__item unshine delay3"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item unshine delay3"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item "></div>
                      <div className="dotz__item "></div>
                      <div className="dotz__item "></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item unshine delay3"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item "></div>
                      <div className="dotz__item shine"></div>
                      <div className="dotz__item "></div>
                      <div className="dotz__item unshine"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item dotz__item--empty"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item "></div>
                      <div className="dotz__item shine delay2"></div>
                      <div className="dotz__item "></div>
                      <div className="dotz__item dotz__item--empty"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item dotz__item--empty"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item shine delay3"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item unshine delay1"></div>
                      <div className="dotz__item "></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item dotz__item--empty"></div>
                      <div className="dotz__item"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item"></div>
                      <div className="dotz__item unshine4"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item unshine delay1"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item shine"></div>
                      <div className="dotz__item unshine delay1"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item "></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item unshine"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item dotz__item--empty"></div>
                      <div className="dotz__item"></div>
                    </div>
                  </div>
                </div>
                <div className="products__icon">
                  <img
                    src={s4}
                    alt=""
                    className="products__icon--main"
                  />
                  <img
                    src={s4}
                    alt=""
                    className="products__icon--sub"
                  />
                </div>
                <div>
                  <div className="products__cardtitle">
                    Децентрализованные биржи (DEX)
                    {/* <img src={goto} alt="" className="goto" /> */}
                  </div>
                </div>
              </div>
            </div>

            <div className="products__column products__column--reverted">
              <div className="products__card">
                <div className="products__hover">
                  <div className="dotz">
                    <div className="dotz__row">
                      <div className="dotz__item shine"></div>
                      <div className="dotz__item dotz__item--empty"></div>
                      <div className="dotz__item dotz__item--empty"></div>
                      <div className="dotz__item "></div>
                      <div className="dotz__item shine delay1"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item "></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item "></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item shine"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item dotz__item--empty"></div>
                      <div className="dotz__item unshine"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item dotz__item--empty"></div>
                      <div className="dotz__item dotz__item--empty"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item "></div>
                      <div className="dotz__item unshine4"></div>
                      <div className="dotz__item "></div>
                      <div className="dotz__item shine delay1"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item dotz__item--empty"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item dotz__item--empty"></div>
                      <div className="dotz__item"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item inshune delay3"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item shine"></div>
                      <div className="dotz__item "></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item "></div>
                      <div className="dotz__item shine delay2"></div>
                      <div className="dotz__item dotz__item--empty"></div>
                      <div className="dotz__item "></div>
                      <div className="dotz__item dotz__item--empty"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item unshine4"></div>
                      <div className="dotz__item "></div>
                      <div className="dotz__item "></div>
                      <div className="dotz__item unshine delay3"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item "></div>
                      <div className="dotz__item "></div>
                      <div className="dotz__item "></div>
                      <div className="dotz__item "></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item "></div>
                      <div className="dotz__item shine"></div>
                      <div className="dotz__item "></div>
                      <div className="dotz__item unshine"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item dotz__item--empty"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item "></div>
                      <div className="dotz__item "></div>
                      <div className="dotz__item shine delay2"></div>
                      <div className="dotz__item "></div>
                      <div className="dotz__item dotz__item--empty"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item dotz__item--empty"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item shine delay3"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item unshine delay1"></div>
                      <div className="dotz__item "></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item dotz__item--empty"></div>
                      <div className="dotz__item"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item"></div>
                      <div className="dotz__item unshine4"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item unshine delay1"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item shine"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item "></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item "></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item unshine"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item dotz__item--empty"></div>
                      <div className="dotz__item"></div>
                    </div>
                  </div>
                </div>
                <div className="products__icon">
                  <img
                    src={s1}
                    alt=""
                    className="products__icon--main"
                  />
                  <img
                    src={s1}
                    alt=""
                    className="products__icon--sub"
                  />
                </div>
                <div>
                  <div className="products__cardtitle">
                    DeFi приложения и&nbsp;криптокошельки
                    {/* <img src={goto} alt="" className="goto" /> */}
                  </div>
                </div>
              </div>
              <div className="products__card">
                <div className="products__hover">
                  <div className="dotz">
                    <div className="dotz__row">
                      <div className="dotz__item shine delay1"></div>
                      <div className="dotz__item shine"></div>
                      <div className="dotz__item dotz__item--empty"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item shine delay1"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item "></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item "></div>
                      <div className="dotz__item shine"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item unshine"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item dotz__item--empty"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item "></div>
                      <div className="dotz__item unshine4"></div>
                      <div className="dotz__item shine delay1"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item dotz__item--empty"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item dotz__item--empty"></div>
                      <div className="dotz__item"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item inshune delay3"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item shine"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item "></div>
                      <div className="dotz__item shine delay2"></div>
                      <div className="dotz__item dotz__item--empty"></div>
                      <div className="dotz__item "></div>
                      <div className="dotz__item dotz__item--empty"></div>
                      <div className="dotz__item"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item unshine4"></div>
                      <div className="dotz__item "></div>
                      <div className="dotz__item "></div>
                      <div className="dotz__item unshine delay3"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item unshine delay3"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item "></div>
                      <div className="dotz__item "></div>
                      <div className="dotz__item "></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item unshine delay3"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item "></div>
                      <div className="dotz__item shine"></div>
                      <div className="dotz__item "></div>
                      <div className="dotz__item unshine"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item dotz__item--empty"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item "></div>
                      <div className="dotz__item shine delay2"></div>
                      <div className="dotz__item "></div>
                      <div className="dotz__item dotz__item--empty"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item dotz__item--empty"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item shine delay3"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item unshine delay1"></div>
                      <div className="dotz__item "></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item dotz__item--empty"></div>
                      <div className="dotz__item"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item"></div>
                      <div className="dotz__item unshine4"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item unshine delay1"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item shine"></div>
                      <div className="dotz__item unshine delay1"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item "></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item unshine"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item dotz__item--empty"></div>
                      <div className="dotz__item"></div>
                    </div>
                  </div>
                </div>
                <div className="products__icon">
                  <img
                    src={s2}
                    alt=""
                    className="products__icon--main"
                  />
                  <img
                    src={s2}
                    alt=""
                    className="products__icon--sub"
                  />
                </div>
                <div>
                  <div className="products__cardtitle">
                    Блокчейн-игры
                    {/* <img src={goto} alt="" className="goto" /> */}
                  </div>
                </div>
              </div>
            </div>

            <div className="products__column">
              <div className="products__card">
                <div className="products__hover">
                  <div className="dotz">
                    <div className="dotz__row">
                      <div className="dotz__item shine delay1"></div>
                      <div className="dotz__item shine"></div>
                      <div className="dotz__item dotz__item--empty"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item shine delay1"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item "></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item "></div>
                      <div className="dotz__item shine"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item unshine"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item dotz__item--empty"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item "></div>
                      <div className="dotz__item unshine4"></div>
                      <div className="dotz__item shine delay1"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item dotz__item--empty"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item dotz__item--empty"></div>
                      <div className="dotz__item"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item inshune delay3"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item shine"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item "></div>
                      <div className="dotz__item shine delay2"></div>
                      <div className="dotz__item dotz__item--empty"></div>
                      <div className="dotz__item "></div>
                      <div className="dotz__item dotz__item--empty"></div>
                      <div className="dotz__item"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item unshine4"></div>
                      <div className="dotz__item "></div>
                      <div className="dotz__item "></div>
                      <div className="dotz__item unshine delay3"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item unshine delay3"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item "></div>
                      <div className="dotz__item "></div>
                      <div className="dotz__item "></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item unshine delay3"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item "></div>
                      <div className="dotz__item shine"></div>
                      <div className="dotz__item "></div>
                      <div className="dotz__item unshine"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item dotz__item--empty"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item "></div>
                      <div className="dotz__item shine delay2"></div>
                      <div className="dotz__item "></div>
                      <div className="dotz__item dotz__item--empty"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item dotz__item--empty"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item shine delay3"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item unshine delay1"></div>
                      <div className="dotz__item "></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item dotz__item--empty"></div>
                      <div className="dotz__item"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item"></div>
                      <div className="dotz__item unshine4"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item unshine delay1"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item shine"></div>
                      <div className="dotz__item unshine delay1"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item "></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item unshine"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item dotz__item--empty"></div>
                      <div className="dotz__item"></div>
                    </div>
                  </div>
                </div>
                <div className="products__icon">
                  <img
                    src={s5}
                    alt=""
                    className="products__icon--main"
                  />
                  <img
                    src={s5}
                    alt=""
                    className="products__icon--sub"
                  />
                </div>
                <div>
                  <div className="products__cardtitle">
                    NFT платформы
                    {/* <img src={goto} alt="" className="goto" /> */}
                  </div>
                </div>
              </div>
              <div className="products__card products__card--crypto">
                <div className="products__hover">
                  <div className="dotz">
                    <div className="dotz__row">
                      <div className="dotz__item"></div>
                      <div className="dotz__item shine delay3"></div>
                      <div className="dotz__item unshine"></div>
                      <div className="dotz__item dotz__item--empty"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item shine delay1"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item "></div>
                      <div className="dotz__item"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item unshine4"></div>
                      <div className="dotz__item dotz__item--empty"></div>
                      <div className="dotz__item shine"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item unshine"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item shine"></div>
                      <div className="dotz__item shine delay1"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item dotz__item--empty"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item dotz__item--empty"></div>
                      <div className="dotz__item"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item inshune delay3"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item shine"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item "></div>
                      <div className="dotz__item shine delay2"></div>
                      <div className="dotz__item dotz__item--empty"></div>
                      <div className="dotz__item "></div>
                      <div className="dotz__item dotz__item--empty"></div>
                      <div className="dotz__item"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item unshine4"></div>
                      <div className="dotz__item "></div>
                      <div className="dotz__item "></div>
                      <div className="dotz__item unshine delay3"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item unshine delay3"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item "></div>
                      <div className="dotz__item "></div>
                      <div className="dotz__item "></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item unshine delay3"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item "></div>
                      <div className="dotz__item shine"></div>
                      <div className="dotz__item "></div>
                      <div className="dotz__item unshine"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item dotz__item--empty"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item "></div>
                      <div className="dotz__item shine delay2"></div>
                      <div className="dotz__item "></div>
                      <div className="dotz__item dotz__item--empty"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item dotz__item--empty"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item shine delay3"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item unshine delay1"></div>
                      <div className="dotz__item "></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item dotz__item--empty"></div>
                      <div className="dotz__item"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item"></div>
                      <div className="dotz__item unshine4"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item unshine delay1"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item shine"></div>
                      <div className="dotz__item unshine delay1"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                    </div>
                    <div className="dotz__row">
                      <div className="dotz__item "></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item unshine"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item"></div>
                      <div className="dotz__item dotz__item--empty"></div>
                      <div className="dotz__item"></div>
                    </div>
                  </div>
                </div>
                <img
                  src={cardbg}
                  className="cardcrypto__bg"
                  alt=""
                />
                <div />

                <div className="products__cardtitle">
                  Все проекты
                  <img
                    src={goto}
                    alt=""
                    className="goto"
                  />
                </div>
              </div>
            </div>
          </div>

          <button
            className="action__button"
            onClick={() => {
              navigate(`?modal`);
            }}
          >
            Давайте обсудим мой проект
          </button>
        </div>
      </section>

      <section
        className="design"
        id="design"
      >
        <div className="dotz">
          <div className="dotz__row">
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
          </div>
          <div className="dotz__row">
            <div className="dotz__item unshine4"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item shine"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item dotz__item--empty"></div>
            <div className="dotz__item dotz__item--empty"></div>
            <div className="dotz__item dotz__item--empty"></div>
            <div className="dotz__item shine delay1"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item unshine4"></div>
            <div className="dotz__item dotz__item--empty"></div>
            <div className="dotz__item dotz__item--empty"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item unshine delay3"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item dotz__item--empty"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item shine delay1"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item dotz__item--empty"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item dotz__item--empty"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
          </div>
          <div className="dotz__row">
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item shine delay2"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item unshine"></div>
            <div className="dotz__item dotz__item--empty"></div>
            <div className="dotz__item dotz__item--empty"></div>
            <div className="dotz__item dotz__item--empty"></div>
            <div className="dotz__item dotz__item--empty"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item shine delay3"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item shine delay1"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item unshine delay2"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
          </div>
          <div className="dotz__row">
            <div className="dotz__item "></div>
            <div className="dotz__item unshine delay1"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item dotz__item--empty"></div>
            <div className="dotz__item dotz__item--empty"></div>
            <div className="dotz__item dotz__item--empty"></div>
            <div className="dotz__item dotz__item--empty"></div>
            <div className="dotz__item dotz__item--empty"></div>
            <div className="dotz__item dotz__item--empty"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
          </div>
          <div className="dotz__row">
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item unshine delay1"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item shine"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item shine delay3"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
          </div>
          <div className="dotz__row">
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item shine4"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item dotz__item--empty"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item unshine4"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item dotz__item--empty"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item shine delay1"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
          </div>
          <div className="dotz__row">
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item dotz__item--empty"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item dotz__item--empty"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
          </div>
          <div className="dotz__row">
            <div className="dotz__item "></div>
            <div className="dotz__item unshine delay2"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item dotz__item--empty"></div>
            <div className="dotz__item shine delay3"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item shine delay2"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item dotz__item--empty"></div>
            <div className="dotz__item shine delay1"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
          </div>
          <div className="dotz__row">
            <div className="dotz__item shine delay3"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item dotz__item--empty"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item shine4"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item unshine"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item dotz__item--empty"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item shine"></div>
            <div className="dotz__item"></div>
          </div>
          <div className="dotz__row">
            <div className="dotz__item"></div>
            <div className="dotz__item unshine delay2"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item unshine delay1"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item unshine4"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
          </div>
          <div className="dotz__row">
            <div className="hide--mobile">
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item unshine delay1"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
            </div>
            <div className="dotz__item unshine delay3"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item unshine4"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item shine"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
          </div>
          <div className="dotz__row">
            <div className="hide--mobile">
              <div className="dotz__item shine"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
            </div>
            <div className="dotz__item shine"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item shine4"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
          </div>
          <div className="dotz__row">
            <div className="hide--mobile">
              <div className="dotz__item unshine4"></div>
              <div className="dotz__item "></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item "></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item "></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
            </div>
          </div>
          <div className="dotz__row">
            <div className="hide--mobile">
              <div className="dotz__item shine delay1"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item "></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item "></div>
              <div className="dotz__item"></div>
              <div className="dotz__item "></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item "></div>
              <div className="dotz__item"></div>
              <div className="dotz__item shine delay4"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item "></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
            </div>
          </div>
          <div className="dotz__row">
            <div className="hide--mobile">
              <div className="dotz__item"></div>
              <div className="dotz__item dotz__item--empty"></div>
              <div className="dotz__item dotz__item--empty"></div>
              <div className="dotz__item dotz__item--empty"></div>
              <div className="dotz__item dotz__item--empty"></div>
              <div className="dotz__item shine delay3"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item "></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item "></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item unshine delay1"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
            </div>
          </div>
          <div className="dotz__row"></div>
          <div className="dotz__row"></div>
          <div className="dotz__row">
            <div className="hide--mobile">
              <div className="dotz__item shine delay1"></div>
              <div className="dotz__item "></div>
              <div className="dotz__item "></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item "></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item shine4"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
            </div>
          </div>
          <div className="dotz__row">
            <div className="hide--mobile">
              <div className="dotz__item unshine4"></div>
              <div className="dotz__item "></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item "></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item "></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
            </div>
          </div>
          <div className="dotz__row">
            <div className="hide--mobile">
              <div className="dotz__item "></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item unshine"></div>
              <div className="dotz__item "></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item "></div>
              <div className="dotz__item shine delay1"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item shine delay3"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
            </div>
          </div>
          <div className="dotz__row">
            <div className="hide--mobile">
              <div className="dotz__item "></div>
              <div className="dotz__item"></div>
              <div className="dotz__item unshine delay3"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item "></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item "></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item unshine delay1"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item "></div>
              <div className="dotz__item"></div>
            </div>
          </div>
          <div className="dotz__row">
            <div className="hide--mobile">
              <div className="dotz__item "></div>
              <div className="dotz__item "></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item "></div>
              <div className="dotz__item "></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item "></div>
              <div className="dotz__item "></div>
              <div className="dotz__item"></div>
              <div className="dotz__item "></div>
              <div className="dotz__item "></div>
            </div>
          </div>
          <div className="dotz__row">
            <div className="hide--mobile">
              <div className="dotz__item unshine4"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item "></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item unshine4 delay1"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
            </div>
          </div>
          <div className="dotz__row">
            <div className="hide--mobile">
              <div className="dotz__item shine"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item "></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item "></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item shine delay1"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
            </div>
          </div>
          <div className="dotz__row">
            <div className="hide--mobile">
              <div className="dotz__item shine delay2"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item "></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item "></div>
              <div className="dotz__item"></div>
            </div>
          </div>
          <div className="dotz__row">
            <div className="hide--mobile">
              <div className="dotz__item "></div>
              <div className="dotz__item shine4"></div>
              <div className="dotz__item "></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item "></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item unshine4"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
            </div>
          </div>
          <div className="dotz__row">
            <div className="hide--mobile">
              <div className="dotz__item "></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item unshine delay1"></div>
              <div className="dotz__item "></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item "></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
            </div>
          </div>
          <div className="dotz__row">
            <div className="hide--mobile">
              <div className="dotz__item "></div>
              <div className="dotz__item unshine delay2"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item "></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item shine delay3"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
            </div>
          </div>
          <div className="dotz__row">
            <div className="hide--mobile">
              <div className="dotz__item unshine delay1"></div>
              <div className="dotz__item "></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item unshine4"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item "></div>
              <div className="dotz__item"></div>
              <div className="dotz__item unshine delay3"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
            </div>
          </div>
          <div className="dotz__row">
            <div className="hide--mobile">
              <div className="dotz__item "></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item "></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item "></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item shine"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
            </div>
          </div>
          <div className="dotz__row">
            <div className="hide--mobile">
              <div className="dotz__item shine delay3"></div>
              <div className="dotz__item "></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item "></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
            </div>
          </div>
          <div className="dotz__row">
            <div className="hide--mobile">
              <div className="dotz__item "></div>
              <div className="dotz__item shine delay2"></div>
              <div className="dotz__item "></div>
              <div className="dotz__item "></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item "></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item shine delay1"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
            </div>
          </div>
          <div className="dotz__row">
            <div className="hide--mobile">
              <div className="dotz__item shine4"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item "></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item "></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item shine delay1"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
            </div>
          </div>
          <div className="dotz__row">
            <div className="hide--mobile">
              <div className="dotz__item "></div>
              <div className="dotz__item shine delay2"></div>
              <div className="dotz__item "></div>
              <div className="dotz__item "></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item "></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="products__title">
            Дизайн-процесс Web3 и крипто-продуктов
          </div>

          <div className="products__desciption">
            Мы&nbsp;проектируем интерфейсы для&nbsp;криптовалют,
            блокчейн-решений и&nbsp;децентрализованных приложений
            с&nbsp;акцентом на&nbsp;удобство, безопасность и&nbsp;инновации
          </div>

          <div className="hide--mobile">
            <div className="design__row design__row--top">
              <div className="design__item">
                <div className="line" />
                <div className="design__itemtitle">
                  Продуктовое исследование
                </div>
                Исследуем рынок. Найдем лучшие практики. Проведем интервью.
              </div>
              <div className="design__item">
                <div className="line" />
                <div className="design__itemtitle">Визуальная стратегия</div>
                Придумаем лого и оформим брендбук. Создадим визуальный язык
                бренда.
              </div>
              <div className="design__item">
                <div className="line" />
                <div className="design__itemtitle">Прототип продукта</div>
                Разрабатываем кликабельный продукт на раннем этапе проработки
              </div>
              <div className="design__item">
                <div className="line" />
                <div className="design__itemtitle">Упаковка</div>
                Продукт без продающей страницы не бываем. Сделаем страницу, сайт
                или портал. Маркетинговые материалы.
              </div>
            </div>

            <div className="design__row design__row--bottom">
              <div className="design__item">
                <div className="line" />
                <div className="design__itemtitle">Тех документация</div>
                Вместе сформулируем требования. Увидим реальные сроки и бюджет.
              </div>
              <div className="design__item">
                <div className="line" />
                <div className="design__itemtitle">Дизайн система</div>
                Документируем правила, сделаем UI компоненты и UX шаблоны
              </div>
              <div className="design__item">
                <div className="line" />
                <div className="design__itemtitle">Дизайн продукта</div>
                Собираем весь проект на основе ТЗ, прототипа, дизайн системы и
                всей обратной связи.
              </div>
            </div>
          </div>

          <div className="hdesktop">
            <div className="designrow">
              <div className="design__item">
                <div className="line">
                  <div className="linedot" />
                </div>
                <div className="design__itemtitle">
                  Продуктовое исследование
                </div>
                Исследуем рынок. Найдем лучшие практики. Проведем интервью.
              </div>
              <div className="design__item">
                <div className="line">
                  <div className="linedot" />
                </div>
                <div className="design__itemtitle">Тех документация</div>
                Вместе сформулируем требования. Увидим реальные сроки и бюджет.
              </div>
              <div className="design__item">
                <div className="line">
                  <div className="linedot" />
                </div>
                <div className="design__itemtitle">Визуальная стратегия</div>
                Придумаем лого и оформим брендбук. Создадим визуальный язык
                бренда.
              </div>
              <div className="design__item">
                <div className="line">
                  <div className="linedot" />
                </div>
                <div className="design__itemtitle">Дизайн система</div>
                Документируем правила, сделаем UI компоненты и UX шаблоны
              </div>
              <div className="design__item">
                <div className="line">
                  <div className="linedot" />
                </div>
                <div className="design__itemtitle">Прототип продукта</div>
                Разрабатываем кликабельный продукт на раннем этапе проработки
              </div>
              <div className="design__item">
                <div className="line">
                  <div className="linedot" />
                </div>
                <div className="design__itemtitle">Дизайн продукта</div>
                Собираем весь проект на основе ТЗ, прототипа, дизайн системы и
                всей обратной связи.
              </div>
              <div className="design__item">
                <div className="line">
                  <div className="linedot" />
                </div>
                <div className="design__itemtitle">Упаковка</div>
                Продукт без продающей страницы не бываем. Сделаем страницу, сайт
                или портал. Маркетинговые материалы.
              </div>
            </div>
          </div>

          <div className="slider">
            <Slider
              className="slider__init"
              {...settings}
            >
              <div className="slider__item">
                <img
                  src={sl1}
                  alt=""
                />
              </div>
              <div className="slider__item">
                <img
                  src={sl2}
                  alt=""
                />
              </div>
              <div className="slider__item">
                <img
                  src={sl3}
                  alt=""
                />
              </div>
              <div className="slider__item">
                <img
                  src={sl4}
                  alt=""
                />
              </div>
              <div className="slider__item">
                <img
                  src={sl5}
                  alt=""
                />
              </div>
              <div className="slider__item">
                <img
                  src={sl6}
                  alt=""
                />
              </div>
              <div className="slider__item">
                <img
                  src={sl7}
                  alt=""
                />
              </div>

              <div className="slider__item">
                <img
                  src={sl8}
                  alt=""
                />
              </div>
            </Slider>
          </div>
        </div>
      </section>

      <CryptoFaq />

      <section className="footersection">
        <div className="container">
          <Footer backgroundColor="transparent" />
        </div>
      </section>

      <ContactUsModal />
    </div>
  );
}

export default CryptoPage;
